import { Component, OnInit, ViewContainerRef } from '@angular/core'
import { NzModalService } from 'ng-zorro-antd/modal'
import {
  QueryTable,
  QueryTableLeaveCollective,
  QueryTableLeaveConfig,
} from 'src/app/services/interface/general.model'
import { NzTableQueryParams } from 'ng-zorro-antd/table'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzNotificationService } from 'ng-zorro-antd/notification'

import { NzButtonSize } from 'ng-zorro-antd/button'
import { AddCollectiveLeaveComponent } from './add-collective-leave/add-collective-leave.component'
import { LeaveManagementService } from 'src/app/services/leave-management/leave-management.service'
import { ViewDetailCollectiveLeaveComponent } from './view-detail-collective-leave/view-detail-collective-leave.component'
import { getYear } from 'date-fns'
import { CollectiveLeaveType } from 'src/app/services/interface/leave-management/leave.model'

@Component({
  selector: 'app-leave-collective',
  templateUrl: './leave-collective.component.html',
  styleUrls: ['./leave-collective.component.scss'],
})
export class LeaveCollectiveComponent implements OnInit {
  size: NzButtonSize = 'large'
  status = ''

  listOfData: CollectiveLeaveType[] = []
  listOfShift = []

  isLoading: boolean = true
  totalData: number = 0
  pageSize: number = 5
  pageIndex: number = 1
  selectedFilter = null
  selectedYear = null

  form: FormGroup
  constructor(
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef,
    private leaveManagementService: LeaveManagementService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
  ) {
    this.form = this.fb.group({
      keyword: [null, Validators.compose([Validators.required])],
      prefix: ['vendor', Validators.compose([Validators.required])],
    })
  }

  queryTable: QueryTableLeaveCollective = {
    sort: { field: null, order: null },
    pageSize: this.pageSize,
    pageIndex: this.pageIndex - 1,
  }

  listOfColumns = [
    {
      name: 'ID',
      key: 'id',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '20px',
    },
    {
      name: 'Actions',
      key: 'actions',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '40px',
    },
    {
      name: 'Holiday Information',
      key: 'title',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '70px',
    },
    {
      name: 'Date',
      key: 'date',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Days',
      key: 'total_leave',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Shift',
      key: 'shift_name',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
  ]

  ngOnInit(): void {
    this.fetchCollectiveLeaveList()
  }

  fetchCollectiveLeaveList() {
    this.isLoading = true
    this.leaveManagementService
      .getListCollectiveLeave(this.selectedYear, this.queryTable)
      .subscribe(
        (r: any) => {
          this.isLoading = false
          this.listOfData = r.rows

          this.totalData = r.count
        },
        (error: any) => {
          this.isLoading = false
        },
      ),
      err => {
        this.fetchCollectiveLeaveList()
      }
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort, filter } = params
    this.queryTable.pageSize = pageSize
    this.queryTable.pageIndex = pageIndex - 1
    const currentSort = sort.find(item => item.value !== null)
    const sortField = (currentSort && currentSort.key) || null
    const sortOrder = (currentSort && currentSort.value) || null

    if (sortField != null && sortOrder != null) {
      this.queryTable.sort = {
        field: sortField,
        order: sortOrder,
      }
    } else {
      this.queryTable.sort = { field: null, order: null }
    }
    this.fetchCollectiveLeaveList()
  }

  reset() {
    this.form.reset()
    this.form.patchValue({ prefix: 'name' })
    this.queryTable.sort = null
    this.selectedYear = null
    this.listOfColumns.forEach(r => {
      r.sortOrder = null
    })
    this.fetchCollectiveLeaveList()
  }

  addLeave() {
    const modal = this.modal.create({
      nzTitle: 'Form Collective Leave',
      nzContent: AddCollectiveLeaveComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {},
      nzMaskClosable: false,
      nzClosable: false,
      nzOkText: 'Submit',
      nzOkDisabled: true,
      nzOnOk: () => {
        const instance = modal.getContentComponent()
        instance.submitForm()
      },
      nzWidth: '75%',
    })
    const instance = modal.getContentComponent()
    modal.afterClose.subscribe(() => {
      this.fetchCollectiveLeaveList()
    })
  }

  deleteLeave(id: string) {
    const modal = this.modal.confirm({
      nzTitle: 'Are you sure cancel this leave?',
      nzContent: '<b style="color: red;">This action cannot be undo</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.leaveManagementService.deleteCollectiveLeave(id).subscribe(
          r => {
            this.fetchCollectiveLeaveList()
          },
          err => {
            this.notification.error('Error', err.error.message)
            this.fetchCollectiveLeaveList()
          },
        )
      },
      nzCancelText: 'No',
      nzOnCancel: () => '',
    })
  }

  viewDetailLeave(leaveId: string) {
    const modal = this.modal.create({
      nzTitle: 'View Detail Collective Leave',
      nzContent: ViewDetailCollectiveLeaveComponent,
      nzStyle: { top: '50px' },
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {
        leaveId: leaveId,
      },
      nzMaskClosable: false,
      nzFooter: [
        {
          label: 'Close',
          danger: true,
          onClick() {
            modal.destroy()
          },
        },
      ],
      nzWidth: '50%',
    })
    modal.afterClose.subscribe(() => this.fetchCollectiveLeaveList())
  }

  onChangeYear(result: Date): void {
    this.selectedYear = String(getYear(result))
    this.fetchCollectiveLeaveList()
  }
}
